// extracted by mini-css-extract-plugin
module.exports = {"errors":"index_errors__3FLT","container":"index_container_36nfl","footerNav":"index_footerNav_3jL_s"};